export default [
    // 会员法宝
    {
        path: '/memberItems',
        component: () => import(/* webpackChunkName:"static-memberItems"*/'@/pages/memberItems/index.vue'),
        name: 'memberItems',
        meta: {
            title: '会员法宝',
        },
    },
    // 用户权益
    {
        path: '/userRights',
        component: () => import(/* webpackChunkName:"static-userRights"*/'@/pages/userRights/index.vue'),
        name: 'userRights',
        meta: {
            title: '会员权益',
        },
    },
    {
        path: '/userRights/blackGoldCard',
        component: () => import(/* webpackChunkName:"static-userRights"*/'@/pages/userRights/blackGoldCard.vue'),
        name: 'userRights/blackGoldCard',
        meta: {
            title: '黑金升级',
        },
    },
    // 活动权益详情
    {
        path: '/activityRightsDetail',
        component: () => import(/* webpackChunkName:"static-activityRightsDetail"*/'@/pages/userRights/activityRightsDetail.vue'),
        name: 'activityRightsDetail',
        meta: {
            title: '活动权益',
        },
    },
    // 亚朵必住
    {
        path: '/atourNeedLive',
        component: () => import(/* webpackChunkName:"static-atourNeedLive"*/'@/pages/userRights/atourNeedLive.vue'),
        name: 'atourNeedLive',
        meta: {
            title: '亚朵必住',
        },
    },
    // app唤起
    {
        path: '/callApp',
        component: () => import(/* webpackChunkName:"static-callApp"*/'@/pages/callApp/index.vue'),
        name: 'callApp',
        meta: {
            title: '亚朵',
        },
    },
    {
        path: '/aboutAtour',
        component: () => import(/* webpackChunkName:"static-aboutAtour"*/'@/pages/aboutAtour/index.vue'),
        meta: {
            title: '亚朵简介',
        },
    },
    {
        path: '/duibaerr',
        component: () => import(/* webpackChunkName:"static-duibaerr"*/'@/pages/error/duibaError.vue'),
        meta: {
            title: '积分商城',
        },
    },

];
